import { AnalyticsWindow } from "../window"

declare let window: AnalyticsWindow

export default function wistiaEvents(_el: HTMLElement, _props: object) {
  if (!window.analytics) return

  // We track the following events related to Wistia videos:
  //   Video played: when the video is played (including after pause)
  //   Video paused: when the video is paused
  //   Video completed: when the video ends
  //   Video progressed: whenever the video advances 10%. Ten events per fully watched video.
  //
  // These events leverage Wistia's API: https://wistia.com/support/developers/player-api

  function handleWistiaVideoReady(video: any) {
    const videoProperties = {
      videoProvider: "wistia",
      videoId: video.hashedId(),
      videoTitle: video.name(),
      videoDurationSeconds: video.duration(),
      url: window.location.href,
      path: window.location.pathname,
    }

    video.bind("play", function () {
      window.analytics?.track("Video played", {
        ...videoProperties,
        startTimeSeconds: roundNumber(video.time()),
      })
    })

    video.bind("pause", function () {
      window.analytics?.track("Video paused", {
        ...videoProperties,
        pauseTimeSeconds: roundNumber(video.time()),
        percentageWatched: roundNumber(video.percentWatched()),
      })
    })

    video.bind("end", function () {
      window.analytics?.track("Video completed", videoProperties)
    })

    const precentageWatchedSteps = [
      1,
      0.9,
      0.8,
      0.7,
      0.6,
      0.5,
      0.4,
      0.3,
      0.2,
      0.1,
    ]

    // @ts-ignore
    video.bind("percentwatchedchanged", function (percent, lastPercent) {
      const currentStep = precentageWatchedSteps.find(value => value <= percent)

      if (currentStep && percent >= currentStep && lastPercent < currentStep) {
        window.analytics?.track("Video progressed", {
          ...videoProperties,
          percentageWatched: currentStep,
        })
      }
    })
  }

  function roundNumber(time: any) {
    return Math.floor(time * 100) / 100
  }

  window._wq = window._wq || []

  // Attach behavior to any Wisita video on the page
  // See: https://wistia.com/support/developers/player-api#get-started
  window._wq.push({ id: "_all", onReady: handleWistiaVideoReady })
}
